import src from "IMAGE";
export default { src, width: 660, height: 660, blurWidth: 0, blurHeight: 0};
